import React from 'react'
import { rankTimedEntries, rankLabel } from './leaderboardRanks'
import { formatElapsed } from './gameLogic'
import { accent, textPrimary, borderDefault } from './styles'

export default function Leaderboard({ data, playerName }) {
  if (!data?.length) return <p style={{ padding: '24px 0', textAlign: 'center', color: '#777' }}>No completed rounds for this day yet.</p>
  const cell = { padding: '14px 8px', borderBottom: `1px solid ${borderDefault}` }
  return <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '.9rem', color: textPrimary }}>
    <thead><tr>{['Rank', 'Player', 'Correct', 'Time'].map((title, i) => <th key={title} scope="col" style={{ ...cell, textAlign: i < 2 ? 'left' : 'right', color: '#777', fontSize: '.75rem' }}>{title}</th>)}</tr></thead>
    <tbody>{rankTimedEntries(data).map(entry => {
      const own = entry.player_name.toLowerCase() === (playerName || '').toLowerCase()
      return <tr key={entry.result_id || entry.player_name} style={{ background: own ? '#fff7ed' : undefined }}>
        <td aria-label={`${entry.tied ? 'Tied for rank' : 'Rank'} ${entry.rank}`} style={{ ...cell, fontWeight: 700 }}>{rankLabel(entry)}</td>
        <td style={cell}>{entry.player_name}{own && <span style={{ color: accent, marginLeft: 6, fontSize: '.7rem' }}>you</span>}</td>
        <td style={{ ...cell, textAlign: 'right', fontWeight: 700 }}>{entry.accuracy}/4</td>
        <td style={{ ...cell, textAlign: 'right', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{formatElapsed(entry.elapsed_ms)}</td>
      </tr>
    })}</tbody>
  </table>
}
